module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/tools/jenkins.plugins.nodejs.tools.NodeJSInstallation/NodeJS_8.9.1/lib/node_modules/@core/macys-cli/node_modules/core-js/modules/_iter-step.js
// module id = 117
// module chunks = 0